import { SxProps, Theme } from "@mui/material";

const styles = {
  container: (theme: Theme): SxProps<Theme> => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "700px",
    margin: "0 auto",
    height: "90vh",
    padding: theme.spacing(4),
    backgroundColor: theme.palette.background.default,

    // Responsive width
    [theme.breakpoints.down("lg")]: {
      width: "600px",
    },
    [theme.breakpoints.down("md")]: {
      width: "500px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  }),

  chatContainer: {
    padding: "16px",
    display: "flex",
    flexDirection: "column",
  },

  header: (theme: Theme): SxProps<Theme> => ({
    marginBottom: theme.spacing(3),
    fontWeight: "bold",
    color: theme.palette.text.primary,
    textAlign: "left",
    mb: 5,
  }),

  divider: (theme: Theme): SxProps<Theme> => ({
    width: "100%",
    height: "2px",
    backgroundColor: theme.palette.divider,
    marginBottom: theme.spacing(3),
  }),

  form: (theme: Theme): SxProps<Theme> => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    width: "100%", // Ensure it spans the container's width
  }),

  textField: (theme: Theme): SxProps<Theme> => ({
    width: "100%", // Aligns with the container's width
  }),

  button: (theme: Theme): SxProps<Theme> => ({
    width: "176px",
    padding: theme.spacing(1.5),
    fontWeight: "bold",
    boxShadow: theme.shadows[2],
    alignSelf: "center",
    height: "40px",
  }),

  infoContainer: {
    paddingLeft: 2,
  },

  chatbotContainer: {
    mt: 4,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  reportContainer: {
    display: "flex",
    marginLeft: "30px",
    marginTop: "5px",
    paddingBottom: "10px",
  },

  mainContainer: {
    padding: "30px 100px",
    height: "calc(100vh - 250px)",
    overflowY: "auto",
  },

  noHeaderInput: {
    mt: 2,
    padding: "0 100px"
  },

  helperText: (theme: Theme): SxProps<Theme> => ({
    paddingLeft: "16px",
    color: theme.palette.text.secondary,
  }),

  inputBase: {
    flex: 1,
    fontSize: "14px",
    paddingLeft: "8px",
  },

  sendButton: {
    width: "36px",
    height: "36px",
    "&:hover": {
      backgroundColor: "#d0d0d0",
    },
  },

  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }
};

export default styles;
